export default __webpack_public_path__ + "static/media/bg.cc1d3d78.png";